import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useMemo } from 'react';
import { useCurrentLocale } from '../../../../../locales/useTranslator';
var oneTrustDetector = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(locale) {
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", new Promise(function (resolve) {
            var _checkOneTrust = function checkOneTrust() {
              var oneTrust = window.OneTrust;
              if (!(oneTrust !== null && oneTrust !== void 0 && oneTrust.ToggleInfoDisplay)) {
                // If OneTrust isn't populated yet, poll until it is.
                // This will run in an infinite loop if OneTrust is disabled,
                // but it's extremely lightweight, so it should be fine.
                setTimeout(_checkOneTrust, 80);
                return;
              }

              // change language immediately to avoid a flash of English text
              // when opening the popup
              oneTrust.changeLanguage(locale);
              resolve(oneTrust);
            };
            _checkOneTrust();
          }));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function oneTrustDetector(_x) {
    return _ref.apply(this, arguments);
  };
}();
export var OneTrustLink = function OneTrustLink(_ref2) {
  var title = _ref2.title;
  var locale = useCurrentLocale();
  var _React$useState = React.useState(function () {}),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    opener = _React$useState2[0],
    setOpener = _React$useState2[1];
  useMemo(function () {
    oneTrustDetector(locale).then(function (oneTrust) {
      setOpener(function () {
        return function () {
          oneTrust.ToggleInfoDisplay();
        };
      });
    });
  }, [locale]);
  return /*#__PURE__*/React.createElement("div", {
    className: "one-trust-link",
    onClick: opener
  }, title);
};